export default __webpack_public_path__ + "static/media/redtail.feb26d81.svg";